import type { ITrainingOffer } from "@bbj-types/offer";
import { useCallback } from "react";
import { axios } from "../axios";

export type TTrainingOfferCreation = Omit<
  ITrainingOffer,
  "offerId" | "externalId" | "source" | "isExpired" | "active" | "publicationDate" | "publicationUpdatedDate"
>;

export const useCreateTrainingOffer = () => {
  const [state, execute, cancel] = axios<ITrainingOffer, TTrainingOfferCreation, unknown>(
    {
      url: "/offers/training",
      method: "post",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (trainingOffer: TTrainingOfferCreation) => {
      return execute({ data: trainingOffer });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
